import { useTranslation as i18nUseTranslation } from "react-i18next";

export function tWrapper(t = (str) => str) {
  return (initialKey, props = {}) => {
    const key = initialKey?.translationKey || initialKey;
    const translationProps = initialKey?.translationProps || {};
    return t(key, { ...props, ...translationProps });
  };
}

export default function useTranslation(...args) {
  const { t, ...rest } = i18nUseTranslation(...args);

  return { t: tWrapper(t), ...rest };
}
